import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-tachograph-file-status-empty-list',
  standalone: true,
  imports: [TranslateModule],
  templateUrl: './tachograph-file-status-empty-list.component.html',
  styleUrls: ['./tachograph-file-status-empty-list.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class TachographFileStatusEmptyListComponent {
  @Input() public desc: string;
}
